module.exports = __webpack_public_path__ + "images/4676e33e21c61ac9b79956a86a2c80d9.png";